import { FC, ReactNode } from 'react';
import V2Table from '@/common/components/Data/V2Table';
import { ButtonProps } from 'antd';
import { useMethods } from '@lhb/hook';
import { isArray, isNotEmpty } from '@lhb/func';
import { parseString, refactorPreviewFileUrl } from '@/common/utils/ways';
import { imagePropertyNames } from '@/views/expandstore/pages/shopEdit/ts-config';
interface TableProps {
  onRefresh?: (value: any) => void
  selectedRowKeys?: any[];
  tableData?: any[];
  setSelectedRowKeys?: (value: any) => void;
  onAction?: (key: string, recoder: any) => void;
  message?: ReactNode;
  onSortOrderChange?: (value: any) => void;
  refreshCurrent?: boolean; // 当前页刷新
  rowSelection?: any;
  onFetch?: () => void;
  filters?: any;
  rowSelectionOperate?: Array<{
    text: string,
    onClick: any,
    icon?: any,
    btnConfig?: ButtonProps
  }>;
  /**
   * @description 从1页重新加载
   */
  reload?: () => void;
  /**
   * @description 从当前页重新加载
   */
   currentReload?: () => void;

   modColumn?: any;

   [key: string]:any;
}

/**
 * @Description 拓店日志-列表
 */
const TableList: FC<TableProps> = ({
  onFetch,
  filters,
  refreshCurrent,
  ...props
}) => {

  const methods = useMethods({
    getLinkName(values) {
      if (!values || !values.length) return '-';
      return <>{values.map((item, idx) => <><a href={refactorPreviewFileUrl(item.url, item.name)} target='_blank'>{item.name}</a>{idx < values.length - 1 ? '、' : ''}</>)}</>;
    },
    getImageName(values) {
      if (!values || !values.length) return '-';
      return <>{values.map((item, idx) => <><a href={item.url} target='_blank'>{item.name}</a>{idx < values.length - 1 ? '、' : ''}</>)}</>;
    },
    renderDescription(recoder: any) {
      if (recoder?.content) {
        const joinTextArr: any = [];

        recoder?.content?.map(item => {
          if (isArray(item.oldValue) || isArray(item.newValue)) {
            const isImage = imagePropertyNames.includes(item.field);
            joinTextArr.push(<>【{item.fieldName || '-'}：{isImage ? methods.getImageName(item.oldValue) : methods.getLinkName(item.oldValue)}-&gt;{isImage ? methods.getImageName(item.newValue) : methods.getLinkName(item.newValue)}】</>);
          } else {
            isNotEmpty(item.oldValue) && (item.oldValue = this.shortenedContent(parseString(item.oldValue), item.field));
            isNotEmpty(item.newValue) && (item.newValue = this.shortenedContent(parseString(item.newValue), item.field));

            joinTextArr.push(<>【{item.fieldName || '-'}：{item.oldValue || '-'}-&gt;{item.newValue || '-'}】</>);
          }

        });

        return <>{recoder.description}{joinTextArr.map(item => item)}</>;
      } else {
        return recoder.description;
      }
    },
    /**
     * @description 对指定字段限制内容最大显示长度，主要针对文本框字段
     * @param value 字段值
     * @param field 字段field
     * @param maxlength 最大长度
     * @return 处理后的文字
     */
    shortenedContent(value, field, maxlength = 10) {
      return field && ['engineeringInfo', 'operationInfo'].includes(field) && value && value.length > maxlength ? value.substring(0, maxlength) + '...' : value;
    }
  });

  const columns = [
    {
      key: 'updatedAt',
      title: '更新时间',
      dragChecked: true,
      importWidth: true,
      width: 216,
    },
    {
      key: 'eventName',
      title: '事件名称',
      dragChecked: true,
      importWidth: true,
      winth: 263,
    },
    {
      key: 'description',
      title: '备注',
      dragChecked: true,
      width: 'auto',
      forceTooltipRender(_: string, recoder: any) {
        return methods.renderDescription(recoder);
      },
      render(_: string, recoder: any) {
        return methods.renderDescription(recoder);
      }
    },
  ];

  return (
    <>
      <V2Table
        rowKey='id'
        filters={filters}
        scroll={{ x: '100%' }}
        defaultColumns={columns}
        onFetch={onFetch}
        refreshCurrent={refreshCurrent}
        voluntarilyEmpty
        hideColumnPlaceholder
        {...props}
      />
    </>
  );
};

export default TableList;
